\# Register a blank function for DI:
window.$DI ?= (x) -> x

# Ensure these guys are loaded first:
window.jQuery       = require 'jquery'
window.Retina       = require 'retina.js/src/retina.js'
_                   = require 'underscore'
window.Sentry       = require '@sentry/browser'
window.Integrations = require '@sentry/integrations'

require 'JSON'
require 'jquery.cookie'
require 'moment'
require '../vendor/jqplot/dist/jquery.jqplot.js'
require '../vendor/jqplot/dist/plugins/jqplot.barRenderer.js'
require '../vendor/jqplot/dist/plugins/jqplot.canvasAxisTickRenderer.js'
require '../vendor/jqplot/dist/plugins/jqplot.canvasTextRenderer.js'
require '../vendor/jqplot/dist/plugins/jqplot.categoryAxisRenderer.js'
require '../vendor/jqplot/dist/plugins/jqplot.dateAxisRenderer.js'
require 'leaflet'
require 'angular'
require 'angular-animate'
require 'angular-sanitize'
require 'angular-ui-router'
require 'angular-leaflet-directive'

# TODO: Remove the redundancy between this test and config.coffee:
local =
  /localhost/.test(window.location.hostname) ||
  /\.local$/.test(window.location.hostname) ||
  /^192\./.test(window.location.hostname)

# TODO: Remove the redundancy between this test and config.coffee:
beta =
  /beta\.cartographer\.io$/.test(window.location.hostname)

# TODO: Remove the redundancy between this test and config.coffee:
next =
  /next\.cartographer\.io$/.test(window.location.hostname)

unless local
  Sentry.init({
    dsn: "https://28f5b70c250846848bb8f8971820a457@sentry.io/2604152"
    integrations: [ new Integrations.Angular() ]
    environment: if beta
      "beta"
    else if next
      "next"
    else
      "production"
  })

module.exports = angular.module 'cartographer.mapwidget', [
  'ng'
  'ngAnimate'
  (if local then [] else ['ngSentry'])...
  'ui.router'
  'leaflet-directive'
  require('../common/common/array').name
  require('../common/common/boolean').name
  require('../common/common/config').name
  require('../common/common/datetime').name
  require('../common/common/debounce').name
  require('../common/common/duration').name
  require('../common/common/http').name
  require('../common/common/location').name
  require('../common/common/log').name
  require('../common/common/number').name
  require('../common/common/promise').name
  require('../common/common/serialize').name
  require('../common/common/storage').name
  require('../common/common/string').name
  require('../common/common/validate').name
  require('../common/api/auth').name
  require('../common/api/code').name
  require('../common/api/feature').name
  require('../common/api/survey').name
  require('../common/api/attachment').name
  require('../common/api/workspace').name
  require('../common/ui/animation').name
  require('../common/ui/modal').name
  require('../common/ui/attachment/thumbnail').name
  require('../common/web-app').name
  require('../chart/histogram').name
  require('../chart/timeline').name
  require('../form/form').name
  require('../form/datetime-field').name
  require('../form/input-group').name
  require('../form/string').name
  require('../map/attribute-layer').name
  require('../map/controls').name
  require('../map/feature-layer').name
  require('../map/feature-map').name
  require('../map/inspector-map').name
  require('../map/layer').name
  require('../map/map').name
  require('../map/marker').name
  require('../map/inspector/inspector').name
  require('../map/inspector/data').name
  require('../map/inspector/attribute').name
  require('../map/inspector/options').name
  require('../map/inspector/photo').name
  require('../plugin/code/common.generated').name
  require('../plugin/code/ces.generated').name
  require('../plugin/code/ecostatus.generated').name
  require('../plugin/code/mrs.generated').name
  require('../plugin/code/nwc.generated').name
  require('../plugin/code/priority-habitats.generated').name
  require('../plugin/code/riverfly.generated').name
  require('../plugin/code/standard.generated').name
  require('../plugin/code/storm.generated').name
  require('../plugin/code/thames21.generated').name
  require('../plugin/code/urs.generated').name
  require('../plugin/code/wrt.generated').name
  require('../plugin/layer/ces.coffee').name
  require('../plugin/layer/ecostatus.coffee').name
  require('../plugin/layer/fba.coffee').name
  require('../plugin/layer/fht.coffee').name
  require('../plugin/layer/mrs.coffee').name
  require('../plugin/layer/nwc.coffee').name
  require('../plugin/layer/priority-habitats.coffee').name
  require('../plugin/layer/riverfly.coffee').name
  require('../plugin/layer/salmon-trout.coffee').name
  require('../plugin/layer/standard.coffee').name
  require('../plugin/layer/storm.coffee').name
  require('../plugin/layer/thames21.coffee').name
  require('../plugin/layer/ucl.coffee').name
  require('../plugin/layer/urs.coffee').name
  require('../plugin/layer/wrt.coffee').name
]

module.exports.config $DI ($locationProvider, $logProvider) ->
  $locationProvider.html5Mode({ enabled: true })
  $logProvider.debugEnabled(process.env.NODE_ENV != 'production')
  return

module.exports.run $DI (crtLog, $rootScope, $window, $location, $timeout, crtConfig) ->
  crtLog.debug('Loaded map widget')
  return

module.exports.controller 'crtMapWidget', $DI ($scope, $location, crtLog, crtConfig, crtHttp, crtLayer, crtInspectorMapQueryParams) ->
  $scope.crtMapWidget = crtMapWidget = this

  urlParams = $location.search()

  parsedParams = crtInspectorMapQueryParams.parse(urlParams, { workspace: null, credentials: null, scrollwheelDefault: false })

  layer = crtLayer.optFindPlugin(parsedParams.layer)

  if layer?.defaultMapEngine == "atlas"
    base = crtConfig.preview.gl.baseUrl

    queryParams = {
      uiembed: true
      workspace: if parsedParams.crossws then null else parsedParams.subdomain
      map: layer.atlasMapId
      # authorization: crtAuth.credentials()?.token
      server: if crtConfig.local
        "development"
      else if crtConfig.beta
        "beta"
      else if crtConfig.next
        "next"
      else
        "production"
      module: parsedParams.module
      survey: parsedParams.survey
    }

    hash = [
      parsedParams.zoom - 1 # Mapbox GL zoom levels are off-by-1 from Leaflet
      parsedParams.location.coordinates[1]
      parsedParams.location.coordinates[0]
    ].join("/")

    redirectUrl = crtHttp.url(base, queryParams, hash)

    window.location.replace(redirectUrl)
  else
    _.extend(crtMapWidget, parsedParams)

  return

# Debugging shortcut:
window.ng = (name) ->
  angular.element(document).injector().get(name)
